import { NgModule } from '@angular/core';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { RouterModule } from '@angular/router';

import { SharedModule } from "app/modules/shared/shared.module";
import { NWMControls } from 'app/components/Controls/NWMControls.module';
import { ProfileComponent } from './profile.component';
import { ProfileResetPasswordComponent } from './profile-reset-password.component';
import { ProfileMyInfoComponent } from "app/modules/profile/profile-myinfo.component";
import { UserProfileCardComponent } from './user-profile-card/user-profile-card.component';
import { RequestToUpdateInformationComponent } from './request-to-update-information/request-to-update-information.component';
import {ReactiveFormsModule} from "@angular/forms";

@NgModule({
    imports: [
        RouterModule,
        NWMControls,
        NgbModule,
        SharedModule.forRoot(),
        ReactiveFormsModule,
        ProfileComponent,
        ProfileMyInfoComponent,
        ProfileResetPasswordComponent,
        UserProfileCardComponent,
        RequestToUpdateInformationComponent
    ],
    providers: []
})
export class ProfileModule { }
